import React from "react";

import { CardDesc, Img, Title, Wrapper } from "./style";

export default function Card({ imageSrc, title }) {
  return (
    <Wrapper>
      <Img>
        <img src={imageSrc} alt="logo" />
      </Img>
      <CardDesc>
        <Title>
          <h2>{title}</h2>
        </Title>
      </CardDesc>
    </Wrapper>
  );
}
